<template>
    <div class="organization-group">
        <div class="organization-top">
            <div class="organization-top-left">
                <span v-has="'02010019'" class="btn-span"><el-button class="bigData-btn-organization-add" type="primary" @click="addGroup">新增</el-button></span>
                <span v-has="'02010020'" class="btn-span">
                    <el-button class="bigData-btn-organization-delete" type="primary" @click="delGroup" :disabled="loginState.bidStatus*1>=30" :loading="loadDel">删除</el-button>
                </span>
                <el-select
                    class="btn-span"
                    v-model="searchObj.userTypeList"
                    placeholder="请选择小组分类"
                    multiple
                    filterable
                    clearable
                    collapseTags
                >
                    <el-option
                        v-for="item in personOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                    ></el-option>
                </el-select>
                <el-button class="bigData-btn-organization-search" type="primary" :loading="loading" @click="handleSearch">查询</el-button>
            </div>
            <div class="organization-top-right" v-has="'02010021'">
                <!-- <el-button class="bigData-btn-organization-mip" type="primary" @click="examine">标书MIP审核</el-button> -->
            </div>
        </div>
        <div class="organization-table">
            <el-table border :data="tableData" v-loading="loading" height="20" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column prop="userTypeText" label="小组分类" width="125"></el-table-column>
                <el-table-column prop="userName" label="姓名" width="105"></el-table-column>
                <el-table-column prop="userCode" label="MIP账号" width="145"></el-table-column>
                <el-table-column prop="email" label="邮箱" width="200" ></el-table-column>
                <el-table-column prop="remark" label></el-table-column>
            </el-table>
            <div class="row-bg">
                <div class="page-text">
                    已选<span class="text-color">{{ selected.length }}</span>项
                </div>
                <MPage
                    :current-page="page.pageNo"
                    :pageData="pageConfig"
                    :total="page.pageTotal"
                    @on-page-change="pageChange"
                    @on-size-change="sizeChange"
                ></MPage>
            </div>
            <add-dialog ref="addStaffDialog" @onFocus="onFocus" @on-type-change="onTypeChange" v-if="addOrderVisible" :visible.sync="addOrderVisible" @perDetermine="perDetermine" ></add-dialog>
            <orgPerson ref="test" :tableData="personData" :isMulti="isMulti" v-if="orgVisible" :visible.sync="orgVisible" @add-perDetermine="addPerDetermine" ></orgPerson>
        </div>
    </div>
</template>
<script>
import addDialog from './personTree/addDialog.vue';
import orgPerson from './personTree/orgPerson';
import MPage from '@/components/supplierPanel/mPage';
import { orgList, addOrgList, delOrgList, seachIspull, mipSpecial, isFlower, seachMaintain } from '../../../../../lsrm/api/bidScheme.js';
import { dictWithUrl } from '@/components/lots/api';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
export default {
    name: 'organizationGroup',
    components: { orgPerson,addDialog, MPage },
    props: {
        TodoPath: {
            type: String
        },
    },
    data() {
        return {
            loading: false,
            loadDel: false,
            addOrderVisible: false,
            orgVisible: false,
            isPullGrade: '', // 是否推送评分
            dictData: {}, // 数字字典
            bidStatus: '',
            examineBtn: '',
            tableData: [],
            personData: [],
            selected: [],
            isMulti:true,
            personOptions: [],
            searchObj: {
                userTypeList: [],
            },
            searchTerm: {},
            page: {
                pageNo: 1,
                pageSize: 30,
                pageTotal: 0,
            },
            pageConfig: {
                layout: 'total, sizes, prev, pager, next, jumper',
                pageSize: 30,
                pageSizes: [10, 20, 30, 50, 100]
            },
        };
    },
    mounted() {
        // 数字字典转换
        dictWithUrl('BID_GROUP_CLASSIFICATION').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data;
                const personOptions = []
                Object.entries(res.data.BID_GROUP_CLASSIFICATION).forEach(item => {
                    personOptions.push({
                        value: item[0],
                        label: item[1],
                    })
                })
                this.personOptions = personOptions
                this.init();
            }
        });
    },
    methods: {
        onTypeChange(row){
            const {staffName,selectTeam}=row
            this.isMulti=true;
            // 60 小组分类-招标小组长
            if(selectTeam === '60'){
                this.isMulti=false;
            }
            if(!staffName){
                this.personData = []
            }
        },
        onFocus(){
            this.orgVisible=true;
        },
        // 新增按钮
        addGroup() {
            this.addOrderVisible = true;
        },
        // 删除按钮
        delGroup() {
            if (this.selected.length === 0) {
                this.$message.warning('请勾选删除数据');
            } else {
                this.$confirm('是否确定要删除选中数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    this.loadDel = true;
                    const res = await delOrgList(this.selected);
                    this.loadDel = false;
                    if (res && res.code === '0') {
                        this.$message({
                            showClose: true,
                            message: '删除成功',
                            type: 'success'
                        });
                        this.init();
                    }
                }).catch(() => {});
            }
        },
        // 组织成员确认带出数据
         addPerDetermine(data, userType, bol) {
            let namelist=[]
            let dataList=[]
            if (this.isPullGrade === 'Y' && (userType === '30' || userType === '40')) {
                this.$message({
                    showClose: true,
                    message: '当前不能添加商务分小组和技术分小组的成员',
                    type: 'warning'
                });
            }
            if(Array.isArray(data)){
                for (const item of data) {
                    dataList.push(item)
                    namelist.push(item.userName)
                }
                let strVal=namelist.join(',')
                this.$refs.addStaffDialog.form.staffName = strVal;
            }
            this.personData = dataList
            this.orgVisible=false;
        },
        hasData(userType){
            let personData = this.personData
            let hasName=''
            for (const item of personData) {
                const {userCode} = item
                for (const tb of this.tableData) {
                    if( tb.userType === userType && tb.userCode === userCode){
                        hasName = `${tb.userTypeText}-${tb.userName}`
                        break;
                    }
                }
            }
            return hasName
        },
        async perDetermine(userType, bol) {
            let data = this.personData
            // 60 小组分类-招标小组长
            let groupLeader = this.tableData.find(item => item.userType === '60')
            let hasPerson=this.hasData(userType);
            if (this.isPullGrade === 'Y' && (userType === '30' || userType === '40')) {
                this.$message({
                    showClose: true,
                    message: '当前不能添加商务分小组和技术分小组的成员',
                    type: 'warning'
                });
            }
            else if(userType === '60' && groupLeader){
                // 60 小组分类-招标小组长
                this.$message({
                    showClose: true,
                    message: '列表已存在招标小组组长，不可以重复添加',
                    type: 'warning'
                });
            }
            else if(hasPerson){
                this.$message({
                    showClose: true,
                    message: `列表已存在 ${hasPerson}，不可以重复添加`,
                    type: 'warning'
                });
            }
            else {
                let deep = [...JSON.parse(JSON.stringify(data))];
                deep = deep.filter(item => {
                    const idList = this.tableData.map(v => v.id);
                    return !idList.includes(item.id);
                });
                const arr = [];
                deep.forEach(item => {
                    const obj = {};
                    obj.bidNo = this.$route.query.bidNo;
                    obj.userType = userType;
                    obj.userName = item.userName;
                    obj.userCode = item.userCode;
                    obj.email = item.email;
                    obj.sex = item.sex;
                    arr.push(obj);
                });
                if (arr.length === 0) {
                    this.$message.warning(`请选择组织成员`);
                    return;
                }
                this.addOrderVisible = bol;
                const res = await addOrgList(arr);
                if (res && res.code === '0') {
                    this.$message({
                        showClose: true,
                        message: '添加成功',
                        type: 'success'
                    });
                    this.init();
                }
            }
        },
        haveMipFn(flowerRes) {
            this.$router.push({
                name: 'mipIframe',
                query: {
                    processId: flowerRes.fdId,
                    path: 'bidScheme',
                    formInstanceId: this.$route.query.bidNo,
                    noticeCode: this.$route.query.bidNo,
                    isBack: true

                }
            });
        },
        // 标书MIP审核 iframe链接接口
        async examine() {
            // 60 小组分类-招标小组长
            let groupLeader = this.tableData.find(item => item.userType === '60')
            //80 完成决标
            if(!groupLeader&&this.bidStatus!=='80'){
                this.$message({
                    showClose: true,
                    message: '请维护招标小组组长',
                    type: 'warning'
                })
                return
            }
            // 查询是否有维护技术和商务
            const isMaintain = await seachMaintain(this.$route.query.bidNo);// 判断是否符合MIP审核
            if (isMaintain && isMaintain.code === '0') {
                const flowerRes = await isFlower({ bussinessCode: this.$route.query.bidNo, auditType: '2' });// 判断是否有流程
                if (flowerRes.data.list.length !== 0) { // 有流程
                    this.haveMipFn(flowerRes.data.list[0]);
                } else { // 没有流程发起流程
                    const strUrl = `${location.origin}${location.pathname}#${this.$route.path}?bidNo=${this.$route.query.bidNo}&defaultComponent=organizationGroup`;
                    if (this.loginState.specialPermitFlag === 'Y') { // 特批
                        const res = await mipSpecial({
                            'tenantCode': this.currentTenant.tenantCode,
                            'appCode': this.applicationCode,
                            'fdTemplateCode': 'srm_bid_team',
                            'loginName': this.$store.getters.user.userCode,
                            'bidNo': this.$route.query.bidNo,
                            'formParam': {
                                'subject': this.$route.query.bidNo + '_' + this.loginState.bidName + '_标书审批_' + this.$store.getters.user.userName,
                                'formInstanceId': this.$route.query.bidNo,
                                'fdUrl': strUrl
                            }
                        }, 'N');
                        this.haveMipFn(res.data);
                    } else { // 不特批
                        const res = await mipSpecial({
                            'tenantCode': this.currentTenant.tenantCode,
                            'appCode': this.applicationCode,
                            'fdTemplateCode': 'srm_bid_team',
                            'loginName': this.$store.getters.user.userCode,
                            'bidNo': this.$route.query.bidNo,
                            'formParam': {
                                'subject': this.$route.query.bidNo + '_' + this.loginState.bidName + '_标书审批_' + this.$store.getters.user.userName,
                                'formInstanceId': this.$route.query.bidNo,
                                'fdUrl': strUrl
                            }
                        }, 'N');
                        this.haveMipFn(res.data);
                    }
                }
            }
        },
        async init() {
            if (this.$route.query.mbpmFlowId && this.mipNum === 1) {
                this.$store.commit('setMipNum', this.mipNum + 1)
                const path = location.hash.replace('#', '')
                this.$router.push({
                    name: 'mipIframe',
                    query: {
                        processId: this.$route.query.mbpmFlowId,
                        path,
                    }
                });
            }
            this.bidStatus = this.loginState.bidStatus;
            // MIP审核按钮是否禁用
            if (this.bidStatus === '00') {
                this.examineBtn = true;
            } else {
                this.examineBtn = false;
            }
            this.loadData()
            // 查看是否已经推送评分
            const res = await seachIspull(this.$route.query.bidNo);
            if (res && res.code === '0') {
                this.isPullGrade = res.data;
            }
        },
        loadData() {
            this.loading = true
            orgList(this.getParams()).then(res => {
                if (res && res.code === '0') {
                    this.tableData = res.data.list;
                    this.conversionData(this.tableData);
                    this.page.pageTotal = res.data.totalCount;
                }
            }).finally(() => { this.loading = false })
        },
        getParams() {
            return {
                ...this.searchTerm,
                bidNo: this.$route.query.bidNo,
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
            }
        },
        conversionData(list) {
            list.map(item => {
                item.userTypeText = this.dictData.BID_GROUP_CLASSIFICATION[item.userType];
            });
            return list;
        },
        handleSearch() {
            this.searchTerm = { ...this.searchObj }
            this.page.pageNo = 1;
            this.loadData()
        },
        pageChange(val) {
            this.page.pageNo = val;
            this.loadData();
        },
        sizeChange(val) {
            this.page.pageNo = 1;
            this.page.pageSize = val;
            this.loadData();
        },
        // 表格选中的数据
        handleSelectionChange(val) {
            this.selected = val;
        }
    },
    computed: { // 获取vuex
        loginState: function() {
            return this.$store.state.bidData;
        },
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode']),
        mipNum() {
            return this.$store.state.mipNum
        },
    },
    watch: {
        TodoPath(val) {
            if (!val) {
                this.examine();
            }
        }
    }

};
</script>
<style lang='less'>
.organization-group {
    padding: 16px;

    .organization-top {
        display: flex;
        justify-content: space-between;

        .el-select {
            width: 215px;
        }
    }
    .btn-span{margin-right: 10px;}

    .organization-table {
        margin-top: 15px;
    }

    .el-table {
        min-height: calc(~ '100vh - 351px');
        max-height: calc(~ '100vh - 351px');
    }
    .el-table--border{ border: 1px solid #ebeef5;}

    .row-bg {
        margin-top: 10px;
    }

    .page-text {
        display: inline-block;
        height: 28px;
        font-size: 12px;
        line-height: 28px;
    }

    .text-color {
        display: inline-block;
        width: 30px;
        text-align: center;
        color: #00bcbf;
    }
}
</style>